import { Sparkles } from "lucide-react";

/**
 * Reusable moment banner component for Phase 1 Gamification.
 * Displays a purple gradient banner with sparkles icon and moment message.
 * A subtle star-sparkle animation plays on mount, hinting that a star
 * has been earned for Your Sky.
 *
 * Used across multiple screen types:
 * - ExplanationCard (answer feedback)
 * - WarmUpToPracticeScreen (WarmUp completion)
 * - PoolACompleteScreen (Pool A completion)
 * - QuestionCard (first Pool B question)
 * - CompleteScreen (Pool B completion / full mastery)
 */

// Tiny star particles — one per spark, stable positions
const SPARKS = [
  { top: "-18px", left: "12%", delay: "0s",    size: 5 },
  { top: "-22px", left: "38%", delay: "0.12s", size: 7 },
  { top: "-16px", left: "64%", delay: "0.06s", size: 4 },
  { top: "-20px", left: "82%", delay: "0.18s", size: 6 },
];

export default function MomentBanner({ moment, className = "" }) {
  if (!moment || !moment.message) return null;

  return (
    <div
      className={`rounded-2xl p-4 bg-gradient-to-r from-violet-500 to-purple-500 border border-violet-300 shadow-lg fade-up moment-banner-wrap ${className}`}
      data-testid="moment-banner"
      data-moment-id={moment.moment_id}
    >
      {/* Star particles floating up */}
      {SPARKS.map((s, i) => (
        <span
          key={i}
          className="moment-spark"
          aria-hidden="true"
          style={{
            top: s.top,
            left: s.left,
            width: s.size,
            height: s.size,
            animationDelay: s.delay,
          }}
        />
      ))}
      <div className="flex items-center gap-3">
        <Sparkles className="w-6 h-6 text-white flex-shrink-0 moment-sparkle-icon" />
        <p className="text-white font-semibold text-base md:text-lg leading-relaxed">
          {moment.message}
        </p>
      </div>
    </div>
  );
}
